/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from 'react'
import { Badge, ButtonBase, ButtonGroup } from '@mui/material'
import styled from '@emotion/styled'
import { Bell } from '@emotion-icons/fa-solid/Bell'
import { ArrowRight } from '@emotion-icons/bootstrap/ArrowRight'
import { Close } from '@emotion-icons/material/Close'
import { Colors, themeSpacing, Typographies, useTypography } from 'src/components/theme'
import { useParsedRouter } from 'src/layout/hooks/use-parsed-router'

const UpdateButton = styled(ButtonBase)`
  display: flex !important;
  align-items: center !important;
  gap: ${themeSpacing(4)}px !important;
  padding: ${themeSpacing(3)}px !important;
  ${useTypography(Typographies.title2m, true)}
  text-transform: capitalize !important;
  color: ${Colors.textWhite} !important;
  background-color: ${Colors.blueDark} !important;
  border-right: none !important;
  border-top-left-radius: 100px !important;
  border-bottom-left-radius: 100px !important;
  &:hover {
    transition: all 0.2s linear !important;
    background-color: ${Colors.blueMedium} !important;
  }
`
const DismissButton = styled(ButtonBase)`
  display: flex !important;
  align-items: center !important;
  gap: ${themeSpacing(4)}px !important;
  padding: ${themeSpacing(3)}px !important;
  color: ${Colors.textWhite} !important;
  background-color: ${Colors.blueDark} !important;
  border-top-right-radius: 100px !important;
  border-bottom-right-radius: 100px !important;
  &:hover {
    transition: all 0.2s linear !important;
    background-color: ${Colors.blueMedium} !important;
  }
`

const BellButton = styled(ButtonBase)`
  display: block !important;
  align-items: center !important;
  padding: ${themeSpacing(0)}px !important;
  color: ${Colors.textWhite} !important;
  background-color: ${Colors.blueDark} !important;
  border-radius: 100px !important;
  height: 42px !important;
  width: 42px !important;
  min-width: 42px !important;
  .MuiBadge-badge {
    padding: 0px !important;
    height: 8px !important;
    width: 8px !important;
    min-width: 8px !important;
  }
  &:hover {
    transition: all 0.2s linear !important;
    background-color: ${Colors.blueMedium} !important;
  }
`

export const RefreshAlert: React.FC = () => {
  const { router } = useParsedRouter()
  const [isMinimized, setIsMinimized] = useState(false)

  if (isMinimized) {
    return (
      <BellButton onClick={() => setIsMinimized(false)}>
        <Badge badgeContent="" color="error">
          <Bell size={16} color={Colors.textWhite} />
        </Badge>
      </BellButton>
    )
  }

  return (
    <ButtonGroup>
      <UpdateButton onClick={() => router.reload()}>
        <Bell size={16} color={Colors.blueLight} />
        <span>A new version of AlphaMap available</span>
        <span>UPDATE NOW</span>
        <ArrowRight size={16} />
      </UpdateButton>
      <DismissButton onClick={() => setIsMinimized(true)}>
        <Close size={16} />
      </DismissButton>
    </ButtonGroup>
  )
}
